<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Owner Portal</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size-xl="3" size-xs="12" size-md="6">
        <ion-card class="welcome-card" [routerLink]="['/live-availability']">
          <img
            src="https://images.homhero.com.au/350x200/homhero/availability.png"
          />
          <ion-card-header>
            <ion-card-title>Live Availability</ion-card-title>
          </ion-card-header>
        </ion-card>
      </ion-col>
      <ion-col size-xl="3" size-xs="12" size-md="6">
        <ion-card class="welcome-card" [routerLink]="['/owner-bookings']">
          <img
            src="https://images.homhero.com.au/350x200/homhero/owner_bookings.png"
          />
          <ion-card-header>
            <ion-card-title>Your Bookings</ion-card-title>
          </ion-card-header>
        </ion-card>
      </ion-col>
      <ion-col size-xl="3" size-xs="12" size-md="6">
        <ion-card class="welcome-card" [routerLink]="['/guest-bookings']">
          <img
            src="https://images.homhero.com.au/350x200/homhero/owner_guest_bookings.png"
          />
          <ion-card-header>
            <ion-card-title>Guest Bookings</ion-card-title>
          </ion-card-header>
        </ion-card>
      </ion-col>
      <ion-col size-xl="3" size-xs="12" size-md="6">
        <ion-card class="welcome-card" [routerLink]="['/booking']">
          <img
            src="https://images.homhero.com.au/350x200/homhero/booknow.png"
          />
          <ion-card-header>
            <ion-card-title>Make a Booking</ion-card-title>
          </ion-card-header>
        </ion-card>
      </ion-col>
      <ion-col size-xl="3" size-xs="12" size-md="6">
        <ion-card class="welcome-card" [routerLink]="['/statement-history']">
          <img
            src="https://images.homhero.com.au/350x200/homhero/statements.png"
          />
          <ion-card-header>
            <ion-card-title>Statement History</ion-card-title>
          </ion-card-header>
        </ion-card>
      </ion-col>
      <ion-col size-xl="3" size-xs="12" size-md="6">
        <ion-card
          class="welcome-card"
          [routerLink]="['/correspondence-history']"
        >
          <img
            src="https://images.homhero.com.au/350x200/homhero/correspondence.png"
          />
          <ion-card-header>
            <ion-card-title>Correspondence History</ion-card-title>
          </ion-card-header>
        </ion-card>
      </ion-col>

      <ion-col
        size-xl="3"
        size-xs="12"
        size-md="6"
        *ngIf="userStore.user && userStore.user.displayMaintenanceInvoices"
      >
        <ion-card class="welcome-card" [routerLink]="['/maintenance-invoices']">
          <img src="https://images.homhero.com.au/350x200/homhero/jobs.png" />
          <ion-card-header>
            <ion-card-title>Maintenance History</ion-card-title>
          </ion-card-header>
        </ion-card>
      </ion-col>
      <ion-col
        size-xl="3"
        size-xs="12"
        size-md="6"
        *ngIf="userStore.user && userStore.user.displayApproveMaintenance"
      >
        <ion-card class="welcome-card" [routerLink]="['/approve-maintenance']">
          <img
            src="https://images.homhero.com.au/350x200/homhero/approval.png"
          />
          <ion-card-header>
            <ion-card-title>Approve Maintenance</ion-card-title>
          </ion-card-header>
        </ion-card>
      </ion-col>
      <ion-col size-xl="3" size-xs="12" size-md="6">
        <ion-card class="welcome-card" [routerLink]="['/messages']">
          <img
            src="https://images.homhero.com.au/350x200/homhero/send_message.png"
          />
          <ion-card-header>
            <ion-card-title>Contact Management</ion-card-title>
          </ion-card-header>
        </ion-card>
      </ion-col>

      <ion-col size-xl="3" size-xs="12" size-md="6">
        <ion-card class="welcome-card" [routerLink]="['/report-maintenance']">
          <img
            src="https://images.homhero.com.au/350x200/homhero/report_maintenance.png"
          />
          <ion-card-header>
            <ion-card-title>Report Maintenance</ion-card-title>
          </ion-card-header>
        </ion-card>
      </ion-col>
      <ion-col
        size-xl="3"
        size-xs="12"
        size-md="6"
        *ngIf="userStore.user && userStore.user.displayHomSureAds"
      >
        <a href="https://homsure.com.au/" target="_blank">
          <ion-card class="welcome-card">
            <img src="/assets/homsure.png" class="ads-image" />
            <ion-card-header>
              <ion-card-title class="ads-title">HomSure</ion-card-title>
            </ion-card-header>
          </ion-card>
        </a>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
